import Reveal from "./Reveal";
import CountUp from "./CountUp";

// =====================================================================
// PRINTS DE FEEDBACK DA V1 (public/escape21/):
// pode adicionar ou remover itens do array; cada print aparece na
// proporção original (sem corte), então formatos variados funcionam.
// =====================================================================
const FEEDBACK_PRINTS = [
  "/escape21/fotofeedback1.jpg",
  "/escape21/fotofeedback2.jpg",
  "/escape21/fotofeedback3.jpg",
  "/escape21/fotofeedback4.jpg",
];

const SocialProof = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-2xl text-center">
      <Reveal>
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-black/35">
          escape21 v2
        </span>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          um ano atrás a gente rodou a{" "}
          <span className="e21-serif">v1</span>. agora vem a{" "}
          <span className="e21-serif">v2</span>, muito maior.
        </h2>
      </Reveal>
      <Reveal delay={120}>
        <p className="mt-8 text-xl font-bold leading-snug tracking-[-0.02em] sm:text-2xl">
          mais de <CountUp end={1500} className="tabular-nums" /> pessoas já
          entraram na lista de espera. e as vagas são limitadas.
        </p>
        <p className="mt-4 text-base text-black/60 sm:text-lg">
          zero anúncio. só gente que também quer sair da média.
        </p>
      </Reveal>
    </div>

    <Reveal delay={200} className="mt-12">
      <p className="mb-5 text-center font-mono text-[11px] uppercase tracking-[0.3em] text-black/35">
        quem viveu a v1 fala assim
      </p>
      {/* carrossel horizontal com scroll-snap; cada print na proporção original */}
      <div className="e21-no-scrollbar -mx-6 flex snap-x snap-mandatory items-center gap-4 overflow-x-auto px-6 sm:justify-center">
        {FEEDBACK_PRINTS.map((src, i) => (
          <img
            key={src}
            src={src}
            alt={`feedback da v1, print ${i + 1}`}
            loading="lazy"
            className={`max-h-[300px] w-auto max-w-[80%] flex-none snap-center rounded-2xl border border-black/10 bg-neutral-100 shadow-sm transition-transform duration-300 hover:rotate-0 hover:scale-[1.03] sm:max-h-[340px] ${
              i % 2 === 0 ? "rotate-1" : "-rotate-1"
            }`}
          />
        ))}
      </div>
    </Reveal>
  </section>
);

export default SocialProof;
